//@ts-check

import React from 'react';

const CheckIcon = ({ height = 14, width = 14, color = 'currentColor' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="14px/Interaction/Navigation/Check/check" fill={color}>
                    <rect id="Rectangle" fillOpacity="0" x="0" y="0" width="14" height="14"></rect>
                    <g id="Outline" transform="translate(2.000000, 2.999961)" fillRule="nonzero">
                        <path
                            d="M9.09313326,0.209419739 C9.25363776,-0.015286554 9.5659128,-0.0673323947 9.7906191,0.0931721005 C10.0153254,0.253676596 10.0673712,0.56595164 9.90686674,0.790657933 L4.90686674,7.79065793 C4.72728173,8.04207693 4.36492119,8.07206681 4.14644661,7.85359223 L0.146446609,3.85359223 C-0.0488155365,3.65833008 -0.0488155365,3.34174759 0.146446609,3.14648545 C0.341708755,2.9512233 0.658291245,2.9512233 0.853553391,3.14648545 L4.436,6.72903884 L9.09313326,0.209419739 Z"
                            id="Path-12"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default CheckIcon;
